import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { InvoiceLinkDetailsType, InvoiceLinkExpiryType, InvoiceLinkModeType } from '@/types/invoiceVaultTypes';

export type CreateInvoiceLinkPayloadType = {
  vault_account_id: string;
  rail: string;
  mode: InvoiceLinkModeType;
  expiry_code: InvoiceLinkExpiryType;
  invoice_number: string;
  amount?: string;
  currency?: string;
  due_date?: string | null;
  description?: string;
};

export const createInvoiceLinkApi = (
  payload: CreateInvoiceLinkPayloadType,
  options?: RequestOptions
): Promise<ApiResponseType<InvoiceLinkDetailsType>> => {
  return authApiService.POST('/invoice-vault/links/', payload, null, options);
};
